import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          浏览内容分类
        </h2>
        <p className="mt-3 text-foreground-600 text-sm md:text-base">
          六大品类，覆盖您所有观影需求
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 cursor-pointer hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
              <i className={`${cat.icon} text-xl md:text-2xl`}></i>
            </div>
            <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-500 mt-1 text-center hidden sm:block">
              {cat.description.slice(0, 20)}...
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}